import styled from 'styled-components';
import { spacing } from 'theme';

export const StyledWrapper = styled.div`
  width: 100%;

  li {
    margin-left: ${spacing('lg')};
    list-style-type: disc;
  }
`;
